import {useQuery} from "@tanstack/react-query";

import {useStoredMe} from "@/src/modules/core/store/me";

import {propertiesService} from "../services";

export function usePropertyTypes() {
  const me = useStoredMe();
  const canFetchPropertyTypes = Boolean(me && !me.isResident);

  const {data, ...query} = useQuery({
    queryKey: ["property-types"],
    queryFn: propertiesService.getPropertyTypes,
    enabled: canFetchPropertyTypes,
    retry: false,
    staleTime: Infinity,
  });

  const propertyTypes = query.isSuccess ? data! : [];

  return {
    propertyTypes,
    ...query,
    isPending: canFetchPropertyTypes && query.isPending,
    isSuccess: canFetchPropertyTypes ? query.isSuccess : true,
  };
}
